import React, { ReactNode } from 'react'
import { Box, Button } from '@node-space/ui-components'
import { BottomContent, DownloadLink } from '../types'

export interface SidePanelHeaderTemplateThreeProps {
  heading?: string
  description?: string
  bottomContent?: BottomContent
  downloadLink?: DownloadLink
  children?: ReactNode
}

export const SidePanelHeaderTemplateThree = ({
  heading,
  description,
  bottomContent,
  downloadLink,
  children,
}: SidePanelHeaderTemplateThreeProps) => {
  return (
    <>
      {heading && <h3 className="pb-1 text-h3 text-foreground-prominent">{heading}</h3>}

      {description && typeof description === 'string' ? (
        <p className="text-body-regular text-foreground-subdued">{description}</p>
      ) : (
        description && <Box>{description}</Box>
      )}

      <Box paddingY={8}>{bottomContent?.leftLabel}</Box>

      {downloadLink?.onClick && downloadLink?.label && (
        <Box flex align="center" paddingT={12} gap={4}>
          {downloadLink?.icon}
          <Button variant="ghost" color="" noPadding onClick={downloadLink?.onClick}>
            {downloadLink?.label}
          </Button>
        </Box>
      )}

      {children && (
        <Box flex paddingT={8}>
          {children}
        </Box>
      )}
    </>
  )
}
